import { workItemIcons } from "app/components/workItemIcons";
import {
  ReportTimeTicket
} from "app/containers/Features/containers/Notification/types";



export const REPORT_TIME_TICKETS: ReportTimeTicket[] = [
  {
    id: "000001",
    title:
      "Login module: There is no confirmation message displayed when user request again...",
    type: "task",
    icon: workItemIcons.task,
  },
  {
    id: "000021",
    title:
      "Login module: There is no confirmation message displayed when user request again...",
    type: "task",
    icon: workItemIcons.task,
  },
  {
    id: "000015",
    title:
      "Login module: There is no confirmation message displayed when user request again...",
    type: "task",
    icon: workItemIcons.task,
  },
  {
    id: "000011",
    title:
      "Login module: There is no confirmation message displayed when user request again...",
    type: "bug",
    icon: workItemIcons.bug,
  },
  {
    id: "000011-3",
    title:
      "Login module: There is no confirmation message displayed when user request again...",
    type: "bug",
    icon: workItemIcons.bug,
  },
  {
    id: "000011-4",
    title:
      "Login module: There is no confirmation message displayed when user request again...",
    type: "bug",
    icon: workItemIcons.bug,
  },
  {
    id: "000011-5",
    title:
      "Login module: There is no confirmation message displayed when user request again...",
    type: "bug",
    icon: workItemIcons.bug,
  },
  {
    id: "000011-6",
    title:
      "Login module: There is no confirmation message displayed when user request again...",
    type: "bug",
    icon: workItemIcons.bug,
  },
];
